var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('zone-select',{attrs:{"zones":_vm.zones,"selected":_vm.selected},on:{"change":function($event){return _vm.$emit('changeZone', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }